import * as React from 'react';
import { Card, Row, Col, Breadcrumb, Divider } from 'antd';
import { IcommonProps } from '../common/props';
import '../../css/ViewProfile.scss';
import Util from '../common/utils';
import { STATICKEYS, staticProperties } from '../common/staticProperties';
import service from '../../service/apolloclient.service';
import { VIEWSTATE } from '../common/constants';
import Auth from '../common/auth';
import { Tasks } from '../common/auth';
// import { BASELINETYPE } from '../common/constants';
import Token from '../common/token';
// import UserIcon from '../../images/illustrationprofile.svg';
import UserList from '../user/UserList';
import ActivityFeed from '../activityFeed/ActivityFeed';
// import LocalStorage from '../../service/localstorage';
import strings from '../../eyeguide-localization/organization/strings.organization.view';
import strings2 from '../../eyeguide-localization/strings.dashboard';
const userIcon = require('../../images/illustration-profile.png');

// class UserIcon extends React.Component {
//     render() {
//         return (
//             <img src={userIcon} />
//         );
//     }
// }
// const storage = new LocalStorage();
/**
 * Property definition 
 */
interface IViewOrganizationProps extends IcommonProps {
    match: any;
    loctaion: any;
}

/**
 * State definition
 */
interface IViewOrganizationState {
    exportModalVisisble: boolean;
    shareModalVisible: boolean;
    shareUsers: any;
    org: any;
    firstname: string;
    lastname: string;
    loading: boolean;
    emptyText: string;
    canEditOrganization: boolean;
    showEditAction: boolean;
    showHealthData: boolean;
}

export default class OrganizationView extends React.Component<IViewOrganizationProps, IViewOrganizationState> {
    iframe: HTMLIFrameElement | null;

    constructor(props: IViewOrganizationProps) {
        super(props); 
        let roleid: number = parseInt(Token.decodeToken().roleid, 10);
        this.state = {
            exportModalVisisble: false,
            shareModalVisible: false,
            shareUsers: [],
            org: [],
            firstname: '',
            lastname: '',
            loading: true,
            emptyText: '',
            canEditOrganization: true,
            showEditAction: Auth.canPerformTask(roleid, Tasks.canEditTest),
            showHealthData: Auth.canPerformTask(roleid, Tasks.canViewHealthData)
        };  
    }

    async componentDidMount() {
        Util.resetScroll();
        staticProperties.set(STATICKEYS.selectedKey, VIEWSTATE.CUSTOMER);
        staticProperties.set(STATICKEYS.selectedRoster, '');
        let data = JSON.parse(this.props.match.params.orgData);
        let org: any = await this.getOrganization(data.organizationid);
        this.setState({
            org: {...org, ...data},
            loading: false,
        });
    }

    // setShareTests(testlist: Array<any>) {
    //     this.setState({
    //         sharetests: testlist
    //     });
    // }

    render() { 
        if ( this.state.loading ) {
            return (
                <div>
                    Loading...
                </div>
            );
        }
        let data = this.state.org;
        console.log('view organization', data);
        let orgName = data.name;
        return (
            <div className="ViewProfile">
            <Card className="cardFont">
            <Breadcrumb>
                <Breadcrumb.Item ><a href="/dashboard">{'Home'}</a></Breadcrumb.Item>
                <Breadcrumb.Item ><a href={'/customer'}> {strings.lsCustomersTxt} </a>
                </Breadcrumb.Item>
                <Breadcrumb.Item >{orgName}</Breadcrumb.Item>
            </Breadcrumb>
            <br/>
            <Row>
                <Col xs={18} sm={12} md={12} lg={2} xl={2}>
                    {/* <Icon type="user" style={{ fontSize: 42}} /> */}
                    {/* <Avatar  size="large" src={userIcon}/> */}
                    <img src={userIcon} />
                    
                </Col>
                <Col xs={18} sm={12} md={12} lg={8} xl={8}>
                    <h2>{orgName}</h2>
                </Col>
                <Col span={3}/>
                <Col>
                    <Row>
                        <Col span={3}>
                            <Row className="countLabels">
                                {strings2.lsTotalProfileTxt}
                            </Row>
                            <Row className="countValues">
                                {data.profiles.toString()}
                            </Row>
                        </Col>
                        <Col span={1}>
                            <Divider className="dividerLine" type="vertical"/>
                        </Col>
                        <Col span={3}>
                            <Row className="countLabels">
                                {strings2.lsTotalBaselineTxt}
                            </Row>
                            <Row className="countValues">
                                {data.baselines.toString()}
                            </Row>
                        </Col>
                        <Col span={1}>
                            <Divider className="dividerLine" type="vertical"/>
                        </Col>
                        <Col span={3}>
                            <Row className="countLabels">
                                {strings2.lsTotalTestTxt}
                            </Row>
                            <Row className="countValues">
                                {data.tests.toString()}
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row>
                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                    <Row className="viewRow">
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} className="clipped leftSpacing">
                            <span className="infoLabels">  {strings.lsActiveTxt}: </span> 
                            <span 
                                className="viewProfileVals" 
                            > {this.state.org.active === 1 ? strings.lsYesTxt : 
                                            strings.lsNoTxt} 
                            </span>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div>
                            <span className="infoLabels">  {strings.lsAddressTxt}: </span> 
                            <span className="viewProfileVals">  {this.state.org.address} </span>
                        </div>
                        </Col>
                    </Row>

                    <Row className="viewRow">
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} className="leftSpacing">
                            <span className="infoLabels">  {strings.lsZipPostalCodeTxt}: </span> 
                            <span className="viewProfileVals">  {this.state.org.pincode} </span>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div>
                                <span className="infoLabels">  {strings.lsCityTxt}: </span> 
                                <span className="viewProfileVals">  {this.state.org.city} </span>
                            </div>
                        </Col>
                    </Row>

                    <Row className="viewRow">
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} className="leftSpacing">
                                <span className="infoLabels">  {strings.lsOrgEmailTxt}: </span> 
                                <span className="viewProfileVals">  {this.state.org.email} </span>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div>
                                <span className="infoLabels">  {strings.lsStateTxt}: </span> 
                                <span className="viewProfileVals">  {this.state.org.state} </span>
                            </div>
                        </Col>
                    </Row>

                    <Row className="viewRow">
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} className="leftSpacing">
                            <span className="infoLabels">  {strings.lsWebsiteTxt}: </span> 
                            <span className="viewProfileVals">  {this.state.org.website} </span>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div>
                                <span className="infoLabels">  {strings.lsCountryTxt}: </span> 
                                <span className="viewProfileVals">  {this.state.org.country} </span>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Card>
            <div >
                <Card 
                    className="cardFont" 
                    title={strings.lsContactInfoTxt} 
                    bordered={false} 
                    style={{ margin: '24px 16px' }} 
                >
                    <Row className="row">
                        <Col xs={12} sm={12} md={12} lg={12} xl={9}>
                            <Row>
                                <Col xs={3} sm={3} md={3} lg={6} xl={6}>
                                    <div className="infoLabels">{strings.lsContactFirstNameTxt}:</div>
                                </Col>
                                <Col  xs={9} sm={9} md={9} lg={18} xl={18}>
                                    <div className="hyphenate"> {this.state.org.contactfirstname}  </div>
                                </Col>
                            </Row>
                            <Row className="rowSpace">
                                <Col xs={3} sm={3} md={3} lg={6} xl={6}>
                                    <div className="infoLabels">{strings.lsContactLastNameTxt}:</div>
                                </Col>
                                <Col  xs={9} sm={9} md={9} lg={18} xl={18}>
                                    <span className="hyphenate"> {this.state.org.contactlastname}  </span>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Row>
                                <Col xs={6} sm={6} md={6} lg={6} xl={3}>
                                    <div className="infoLabels">{strings.lsContactPhoneTxt}:</div>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span className="hyphenate"> {this.state.org.contactphone}  </span>
                                </Col>
                            </Row>
                            <Row className="rowSpace">
                                <Col xs={6} sm={6} md={6} lg={6} xl={3}>
                                    <div className="infoLabels">{strings.lsContactEmailTxt}:</div>
                                </Col>
                                <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                                    <span className="hyphenate"> {this.state.org.contactemail}  </span>
                                </Col>
                            </Row>
                        </Col>
                        </Row>
                </Card>
                <Card className="cardFont" title={strings.lsUserListTxt} style={{ margin: '24px 16px' }}>
                    <UserList
                        organizationID={this.props.organizationID} 
                        rosterID={this.props.rosterID} 
                        organizationName={this.props.organizationName}
                        enableTitleSpace={this.props.enableTitleSpace}
                        users={this.state.org.users}
                        notifyActiveClick={undefined}
                        notifyResetClick={undefined}
                        loading={this.state.loading}
                        emptyText={this.state.emptyText}
                        showAction={false}
                        showOrg={false}
                        showActiveCol={true}
                    />   
                </Card>
            </div><br/>
            {
                data.isprimary &&
                <ActivityFeed 
                    feedSize={60}
                    isCustomer={true}
                    rosterid={this.state.org.organizationid}
                />
            }
            </div>
        );
    }

    /**
     * Returns value of the property
     * @param property attribute name to extract value from props.org
     * @param defaultVal default value, if attribute not found
     */
    // private getInputValue(property: string, defaultVal: string): string {
    //     let metaInfoMap = this.metaInfoMap;
    //     let defaultValue: string = '';
    //     let playerinfo = this.state.org !== '' &&  (this.state.org !== undefined && 
    //         this.state.org.playerinfo !== undefined)
    //                 ? this.state.org.playerinfo.filter((e: any) => 
    //                             e.playerinfoname === property) : '';
    //     if (playerinfo.length === 0) {
    //         // defaultValue = this.getDisbledColumnVal(property, this.metaInfoMap);
    //         if (metaInfoMap !== '' && metaInfoMap !== undefined && metaInfoMap.length > 0) {
    //             let metaInfo: any = metaInfoMap.filter( (x: any) => 
    //                 x.metainfoname === property
    //             );
    //             if (metaInfo.length > 0) {
    //                 defaultValue = metaInfo[0].metainfovalue;
    //             }
    //         }
    //     }
    //     return playerinfo.length !== 0 ? playerinfo[0].playerinfovalue : defaultValue;
    // }

    /**
     * Returns date from miliseconds.
     * @param attr date attribute whose value needs to be fetched for formatting
     * @param defaultVal default value to be set if no value provided
     */
    // private formatDate(attr: string, defaultVal: string): any {
    //     console.log('formatdate');
    //     let dobInMS = this.getInputValue(attr, defaultVal);
    //     console.log('dobinMS', dobInMS);
    //     let dateVal: any = '';
    //     if (dobInMS !== '') {
    //         dateVal = moment(parseInt(dobInMS, 10));
    //         return moment(dateVal).format('MMMM DD[,] YYYY'); 
    //     }
    // }

    /**
     * Returns array of values obtained by splitting on ','
     * @param commaSepList String containing comma seperated list
     */
    // private getCommaStringWithSpace(commaSepList: string) {
    //     let values: any = commaSepList !== null ? commaSepList.split(',') : [];
    //     let commaSepString: string = '';
    //     if (values.length > 0) {
    //         for (let i = 0; i < values.length; i++) {
    //             if (i === values.length - 1) {
    //                 commaSepString += values[i]; 
    //             } else {
    //                 commaSepString += values[i] + ', '; 
    //             }
    //         }
    //         return commaSepString;
    //     } else {
    //         return commaSepList;
    //     }
    // }

    // private getName(value: any, list: any) {
    //     return list[value];
    // }

    // private printList() {
    //     console.log('orgsFromPrint', this.state.org.tests);
    //     let buildData: any;
    //     buildData = this.buildTestData(this.state.org.tests);
    //     if (buildData.length > 0) {
    //         Print.printContents(buildData, 'Tests', this.iframe);
    //     }
    // }

    // private exportFile() {
    //     console.log('orgsFromPrint', this.state.org.tests);
    //     let buildData: any;
    //     buildData = this.buildTestData(this.state.org.tests);
    //     if (buildData.length > 0) {
    //         Export.exportCSVFile(buildData, 'tests');
    //         this.setState({exportModalVisisble: true});
    //     }
    // }

    // private buildTestData(tests: Array<any>) {
    //     let columnData: Array<any> = [];
    //     tests.forEach( (element: any) => {
    //         let data: any = {};
    //         if (this.state.showHealthData) {
    //             data = {
    //                 name: element.athlete.firstname + ' ' + element.athlete.lastname,
    //                 date_and_time: Util.getDate(element.testtimestamp) + ' ' + Util.getTime(element.testtimestamp),
    //                 dr_dx_concussion: Util.getConcussed(element.concussed),
    //                 score: Util.formatNumber(element.score, 2),
    //             };
    //         }  else {
    //             data = {
    //                 name: element.athlete.firstname + ' ' + element.athlete.lastname,
    //                 date_and_time: Util.getDate(element.testtimestamp) + ' ' + Util.getTime(element.testtimestamp),
    //                 test_type: element.baseline === 1 ? BASELINETYPE.BASELINE : BASELINETYPE.TEST,
    //             };
    //         }
    //         columnData.push(data);
    //     }); 
    //     return columnData;
    // }

    private async getOrganization(orgId: any) {
        let ser = new service(); 
        let org = await ser.getOrganizationWithUsers(orgId);
        console.log('getOrganization', org);
        return org;
    }
}


// WEBPACK FOOTER //
// ./src/components/organization/ViewOrganization.tsx